import { useState, useEffect } from 'react'
import { useRegisterManager } from '../../../ng-compat/hooks'

/**
 * Hook to get the currency symbol for the current outlet
 * TODO: activeOutlet should be stored in redux, so querying currency symbol is easier
 */
export const useCurrencySymbol = () => {
  const registerManager = useRegisterManager()

  const [symbol, setSymbol] = useState<string>(
    () => registerManager.getActiveOutlet()?.currency_symbol ?? '$'
  )

  useEffect(() => {
    const onActiveOutletChanged = () => {
      setSymbol(registerManager.getActiveOutlet()?.currency_symbol ?? '$')
    }
    registerManager.on('activeOutletChange', onActiveOutletChanged)
    return () => {
      registerManager.off('activeOutletChange', onActiveOutletChanged)
    }
  }, [registerManager])

  return symbol
}
